initImageZoom({
  moduleSelector: '.about-module',
  innerSelector: '.about-module__image-inner',
  duration: '50%',
  triggerHook: 0,
});
